import React from "react";
import Button from "@mui/material/Button";

import UploadIcon from "../../assets/UploadDocument.svg";
import { useTranslation } from "react-i18next";
import { SUPPORTED_DOCUMENT_ACCEPT } from "../../utils/fileValidation";

interface UploadDocumentProps {
  uploadDocument: (files: File[]) => void;
  disabled: boolean;
}

export default function UploadDocumentButton(
  props: UploadDocumentProps & { style?: React.CSSProperties },
) {
  const { disabled, uploadDocument, style } = props;
  const { t } = useTranslation();

  const inputRef = React.useRef<HTMLInputElement>(null);

  const handleClick = () => {
    inputRef?.current?.click(); // opens file picker
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const files = Array.from(e.target.files || []);
    uploadDocument(files);
  };

  return (
    <div style={{ cursor: disabled ? "not-allowed" : "pointer" }}>
      {/* hidden input — lives outside the button */}
      <input
        ref={inputRef}
        type="file"
        accept={SUPPORTED_DOCUMENT_ACCEPT}
        multiple
        style={{ display: "none" }}
        onChange={handleChange}
      />

      <Button
        variant={style ? "text" : "contained"}
        startIcon={
          !style ? <img src={UploadIcon} alt="Upload Document" /> : undefined
        }
        style={
          style
            ? { ...style, cursor: disabled ? "not-allowed" : "pointer" }
            : {
                backgroundColor: "#40b4b4",
                border: "none",
                color: "white",
                borderRadius: "10px",
                cursor: disabled ? "not-allowed" : "pointer",
              }
        }
        disabled={disabled}
        onClick={handleClick}
        data-testid="upload-documents-button"
      >
        {t("uploadDocuments")}
      </Button>
    </div>
  );
}
